"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _InputGroup = require("@insided/shared/uikit/InputGroup");

var _typeGuards = require("../../libs/typeGuards");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InputGroupWithSubdomain = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(InputGroupWithSubdomain, _PureComponent);

  var _super = _createSuper(InputGroupWithSubdomain);

  function InputGroupWithSubdomain(props) {
    var _props$id;

    var _this;

    (0, _classCallCheck2.default)(this, InputGroupWithSubdomain);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "randomId", void 0);
    _this.randomId = (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : (0, _InputGroup.createRandomString)(8);
    return _this;
  }

  (0, _createClass2.default)(InputGroupWithSubdomain, [{
    key: "render",
    value: function render() {
      var _ref, _props$qaClasses;

      var props = this.props;
      var addErrorStyleToInput = (_ref = props.error && props.error !== '') !== null && _ref !== void 0 ? _ref : props.hasError;
      return (0, _preact.h)("div", {
        className: "form-group form-group--new-style"
      }, (0, _preact.h)("div", null, (0, _preact.h)("label", {
        htmlFor: this.randomId,
        className: props.title ? undefined : 'hide-label'
      }, props.title), props.optional ? ' (optional)' : null, props.meta ? (0, _preact.h)("p", {
        className: "input-label-meta-text"
      }, props.meta) : null, (0, _preact.h)("div", {
        className: "form-group"
      }, (0, _preact.h)("div", {
        className: "input-wrapper"
      }, (0, _preact.h)("input", {
        className: "form-control input-domain ".concat((_props$qaClasses = props.qaClasses) !== null && _props$qaClasses !== void 0 ? _props$qaClasses : '', " ").concat(addErrorStyleToInput ? 'validation-error' : ''),
        id: this.randomId,
        value: props.value,
        name: props.name,
        min: props.min,
        max: props.max,
        required: props.required,
        disabled: props.disabled,
        readOnly: !!props.readOnly,
        placeholder: props.placeholder,
        onClick: function onClick(e) {
          if (props.onClick && (0, _typeGuards.isInputClickEvent)(e)) {
            props.onClick();
          }
        },
        onChange: function onChange(e) {
          if (props.onChangeCallback && (0, _typeGuards.hasValueInEventTarget)(e)) {
            props.onChangeCallback(e);
          }
        }
      }), props.subdomain && (0, _preact.h)("span", {
        className: "post-subdomain-wrapper input-subdomain-wrapper"
      }, props.subdomain)))), props.error && props.error !== '' ? (0, _preact.h)("div", {
        className: "validation-error error-message"
      }, (0, _preact.h)(_assets.default, {
        customClass: "icon-warning",
        icon: "warning"
      }), (0, _preact.h)("span", {
        className: "error-message-text"
      }, props.error)) : null);
    }
  }]);
  return InputGroupWithSubdomain;
}(_preactCompat.PureComponent);

var _default = InputGroupWithSubdomain;
exports.default = _default;